// extracted by mini-css-extract-plugin
export default {"banner":"AssigneePicker-module__banner--hCy0m","assigneePickerContainer":"AssigneePicker-module__assigneePickerContainer--R4yS0"};